module.exports = __webpack_public_path__ + "img/icon_situation_leave.5f61e60.svg";